import { createSelector } from 'reselect'

const getMyLibrary = state => state.myLibrary

const myLibraryCurrentFolderLessonSelector = createSelector(
	[getMyLibrary],
	myLibrary => {
		let presentationsCount = myLibrary.lessons.length
		myLibrary.folders.forEach(folder => {
			presentationsCount += folder.presentationsCount
		})

		return presentationsCount
	}
)

export default myLibraryCurrentFolderLessonSelector
